import * as React from "react"
import {useEffect} from "react"
import {useSignal} from "@preact/signals-react";
import {Box, CircularProgress, Typography} from "@mui/material";


export default function MatchersLoadingSkuBlock() {
	const dots = useSignal(0)

	useEffect(() => {
		const interval = setInterval(() => {
			if (dots.value < 3)
				dots.value += 1
			else dots.value = 0
		}, 500)

		return () => clearInterval(interval)
	}, []);

	return <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={1}>
		<CircularProgress size="2.5rem" />
		<Typography variant="caption">
			Loading Skus, please wait{'.'.repeat(dots.value)}
		</Typography>
	</Box>
}